import { Injectable } from '@angular/core';
import { IIDolServizioAggiuntivoStore } from './iidOlServizioAggiuntivo.store';
import { IID_OL_SERVIZIO_AGGIUNTIVO } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolServizioAggiuntivoQuery } from './iidOlServizioAggiuntivo.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestOloNetwork } from '@ep-om/project/components/interfaces/OL_ServizioAggiuntivo/interface.component';
import { AnagraficaServiziQuery } from '../anagraficaServizi/anagraficaServizi.query';
import { IAnagraficaServizioAggiuntivo } from '@common/interfaces/anagraficaServizioAggiuntivo';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.SERVIZIO_AGGIUNTIVO)
export class IIDolServizioAggiuntivoService extends CrudService<IID_OL_SERVIZIO_AGGIUNTIVO, IIDolServizioAggiuntivoStore, IIDolServizioAggiuntivoQuery> {
   
  constructor(
    protected store: IIDolServizioAggiuntivoStore,
    public query: IIDolServizioAggiuntivoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    protected anagraficaServiziQuery: AnagraficaServiziQuery,
    protected httpClient: HttpClient
  ) {
    super(
      Topics.IID_OL_SERVIZIO_AGGIUNTIVO,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  getServicesByOloRequest$(request: RequestOloNetwork, connected: boolean, items: IID_OL_SERVIZIO_AGGIUNTIVO[]): Observable<IAnagraficaServizioAggiuntivo[]> {
    if (!connected || !request?.type || !request?.olo) {
      const idsSet = new Set<string>(items.map(item => item.anagraficaServizioAggId));
      return this.anagraficaServiziQuery.selectAll({filterBy: svc => idsSet.has(svc.id)});
    }
    if (request.type === 'olo') {
      return this.anagraficaServiziQuery.selectAll();
    }
    return this.httpClient.get<IAnagraficaServizioAggiuntivo[]>(`${environment.apiUrl}/api/OloNetwork/anagraficheServiziAgg?oloName=${request.olo}&network=${request.network}`);
  }
}
